import Yup from '../yup';

const exisitingOrder = {
  eo_case_no: Yup.string()
    .nullable()
    .notRequired(),
  eo_aprox_date: Yup.string()
    .trim()
    .transform((value?: string) => (value ? value : undefined))
    .nullable()
    .notRequired()
    .csvDate('Invalid date', true)
    .csvDatePast(),
  eo_expiry: Yup.string()
    .trim()
    .transform((value?: string) => (value ? value : undefined))
    .nullable()
    .notRequired()
    .csvDateFuture(true, 'The date you have entered is a past date. An application to extend, vary or revoke **cannot be made on an expired intervention order**. Do not proceed with this application. Please contact the court or make a new application for an intervention order [here](https://fvio.mcv.vic.gov.au/).'),
};

export default exisitingOrder;